import { Card, fontStyles, Icon } from '@monash/portal-react';
import c from './ineligible-card.module.scss';
import cs from '../../service-page.module.scss';
import classNames from 'classnames';
import InfoHeader from '../info-header/InfoHeader';

const IneligibleCard = ({ reasons, name, description, externalLink }) => {
  return (
    <Card className={c.cardContainer}>
      <div className={classNames(cs.alert, c.ineligible)}>
        <Icon.Alert />
        <div className={cs.alertTextContainer}>
          <div className={classNames(fontStyles.heading, fontStyles.sm)}>
            You're not eligible for this role yet
          </div>
          <div className={c.reasons}>
            {reasons?.map((reason) => (
              <div key={reason} className={c.reason}>
                <Icon.X size={16} />
                {reason}
              </div>
            ))}
          </div>
        </div>
      </div>
      <InfoHeader
        name={name}
        description={description}
        externalLink={externalLink}
      />
    </Card>
  );
};

export default IneligibleCard;
